import { z } from 'zod';

import { divisionId } from '../Division/Division';
import { schemaId } from '../utils/schema.utils';

// customerIdentity is free-form: Meta may send phone numbers or BSUIDs (e.g. "DE.abc123xyz789") from June 2026.
// divisionId optional: pre-field chats lack it; Manta only sets it when DivisionPhoneCache has the inbound phoneNumberId.
export const schemaChatCreatedPayload = z.object({
    customerIdentity: z.string().min(1),
    divisionId: divisionId.optional(),
    loanRequestId: schemaId.optional(),
    partnerId: schemaId.optional(),
    phoneNumberId: z.string().min(1),
});

export type Schema_ChatCreatedPayload = z.infer<typeof schemaChatCreatedPayload>;
